import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const StoreGetTenant = {
  Type: "storeGetTenant",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: StoreGetTenant.Type,
      goto: "",
      errorGoto: "",
      missingParamsGoto: "",
      multipleTenantsGoto: "",
      notFoundGoto: ""
    };
    let data = StoreGetTenant.PlumbData(node as NodeInterface);
    (node as any).layout = data.node.layout;
    return node; //
  },
  PlumbData: function (node: NodeInterface) {
    const tabs = [
      {
        id: "goto",
        source: "goto",
        target: node.goto,
        title: "Success"
      },
      {
        id: "errorGoto",
        source: "errorGoto",
        target: node.errorGoto,
        title: "Error"
      },
      {
        id: "missingParamsGoto",
        source: "missingParamsGoto",
        target: node.missingParamsGoto,
        title: "Missing Params"
      },
      {
        id: "multipleTenantsGoto",
        source: "multipleTenantsGoto",
        target: node.multipleTenantsGoto,
        title: "Multiple Tenants Found"
      },
      {
        id: "notFoundGoto",
        source: "notFoundGoto",
        target: node.notFoundGoto,
        title: "Not Found"
      }
    ];
    return TabNodeLayoutData({
      node: node,
      title: "Get Tenant",
      baseWidth: 170,
      tabs: tabs
    });
  },
  InspectorPanel: class InputInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
    }

    render() {
      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Tenant Lookup" />
            {/* <div className="note">Variable "User - Tenant Id" must be set.</div> */}
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};

export default StoreGetTenant;
